module.exports = __webpack_public_path__ + "img/pinjam_uang.f8f522a1.png";